import { Form, FormField, FormLabel, FormInput, Button } from '../ui';
import type { Promotion } from '../../types/promotion';
import { formatDate } from '../../lib/formatters';

interface PromotionFormProps {
  promotion: Promotion | null;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function PromotionForm({ promotion, onSubmit, isLoading, onClose }: PromotionFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="name" required>
          Nome
        </FormLabel>
        <FormInput id="name" name="name" defaultValue={promotion?.name} required />
      </FormField>

      <FormField>
        <FormLabel htmlFor="start_date" required>
          Data Início
        </FormLabel>
        <FormInput
          type="date"
          id="start_date"
          name="start_date"
          defaultValue={promotion?.start_date ? formatDate(promotion.start_date, 'iso') : undefined}
          required
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="end_date" required>
          Data Fim
        </FormLabel>
        <FormInput
          type="date"
          id="end_date"
          name="end_date"
          defaultValue={promotion?.end_date ? formatDate(promotion.end_date, 'iso') : undefined}
          required
        />
      </FormField>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {promotion ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default PromotionForm;
